import { useCan } from "@refinedev/core";
import { Box, Typography, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router";
import type { ReactNode } from "react";

export const RouteGuard = ({
  resource,
  action,
  children,
}: {
  resource: string;
  action: string;
  children: ReactNode;
}) => {
  const { data, isLoading } = useCan({ resource, action });
  const navigate = useNavigate();

  if (isLoading) return null;

  if (data?.can === false) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 2 }}>
        <BlockIcon sx={{ fontSize: 48, color: "text.disabled" }} />
        <Typography variant="h6" color="text.secondary">Access Denied</Typography>
        <Typography variant="body2" color="text.disabled">You don't have permission to view this page.</Typography>
      </Box>
    );
  }

  return <>{children}</>;
};
